module.exports = __webpack_public_path__ + "media/images/why-ih-2-37d751a1ac47720515e0d72ef36941ee.svg";